// ------------------------------------------------------------------------------
// name: status
// author: mudas
// created: 2025/1/9
// ------------------------------------------------------------------------------

// 资质认证状态
export enum QualificationStatus {
  Unverified = 0, // 未认证
  Waiting = 1, // 等待审核
  Failed = 2, // 审核不通过
  Verified = 3, // 审核通过
}

export enum RecommendStatusEnum {
  None, // 无状态
  Recommended, // 已推荐
  Invited, // 已邀请
  Applied, // 已申请
}
